import { getStoreConfig } from 'config'
import useSWR from 'swr'

export interface YotpoReviewsAPI {
    id: string
}

const fetcher = (url: string) => fetch(url).then((response) => response.json())

export const YotpoReviewsAPI = ({ id }: YotpoReviewsAPI) => {
    const config = getStoreConfig()

    try {
        const response = useSWR(
            `https://api-cdn.yotpo.com/v1/widget/${config.base.yotpo.api_key}/products/${id}/reviews.json?per_page=5&sort=rating`,
            fetcher
        )
        return response?.data
    } catch (e) {
        console.warn(e)
    }
}
